import { accountAuthStrategy } from './auth-strategies/index.js';

export const { isLoggedIn: isLoggedInToAccount } = accountAuthStrategy;

export { logout } from './logout.js';
export { getUserInfo } from './auth-data.js';
export type { UserInfo } from './schemas.js';
export { useAuth } from './useAuth.js';
export { ApiKeyLogin } from './components/ApiKeyLogin.js';
export { LoginWithI18n as Login } from './components/Login.js';
export { AccountAuthProvider } from './providers/AccountAuthProvider.js';
export { SiteAuthProvider } from './providers/SiteAuthProvider.js';
export { authenticateWithSiteId } from './authenticate.js';
export type { AuthState } from './context.js';
